import Button from '@mui/material/Button';
// import {AppBar, Toolbar, Typography,} from "@material-ui/core";
import Nav from './nav';
import axios from 'axios';

import React, {Component} from 'react';
import {Alert, Container, Grid, ImageList, ImageListItem} from "@mui/material";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


axios.defaults.baseURL = window.location.protocol + '//' + window.location.host.replace("3000", "8007");


class LoadImages extends Component {
    state = {files: [], urls: [], result: ''};

    fileChangeHandler = (e) => {
        const files = [...this.state.files]; // Spread syntax creates a shallow copy
        files.push(...e.target.files); // Spread again to push each selected file individually
        this.setState({files});
        this.setFileUrls(files)
    }

    handleSubmit = (e) => {
        const files = new FormData();
        this.state.files.forEach((file) => files.append('files', file, file.name));
        console.log(this.state.files);
        axios.post("/uploadfiles/", files).then((response) => {
            this.setState({result: response.data.result})
            this.setState({files: [], urls: []});

        });

    }


    setFileUrls(files) {
        const urls = files.map((file) => URL.createObjectURL(file));
        if (this.state.urls.length > 0) {
            this.state.urls.forEach((url) => URL.revokeObjectURL(url));
        }
        this.setState({urls});
    }

    displayUploadedFiles(urls) {
        return urls.map((url, i) => <img key={i} src={url}/>);
    }

    render() {

        return (
            <Container>
                <Nav/>
                <div>
                    <h1>
                        Добавление изображений
                    </h1>
                    <div>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>

                                <Button variant="contained" component="label" color="primary">
                                    {" "}
                                    Загрузить изображения
                                    <input id="image" type="file" multiple="multiple" onChange={this.fileChangeHandler}
                                           hidden/>
                                </Button>
                            </Grid>

                            <Grid item xs={6}>
                                <Button variant="contained" component="label" color="primary">
                                    {" "}
                                    Добавить изображения в базу
                                    <input type="button" onClick={this.handleSubmit} hidden/>
                                </Button>
                            </Grid>
                        </Grid>
                        {this.state.result &&

                        <Grid item xs={6} >
                            <br/>
                           <Alert severity="success">{this.state.result}</Alert>
                        </Grid>
                        }
                        {this.state.urls.length > 0 &&
                        <ImageList sx={{width: 500, height: 450}} cols={1} rowHeight={164}>

                            <ImageListItem>{this.displayUploadedFiles(this.state.urls)}</ImageListItem>
                        </ImageList>}
                    </div>

                </div>
            </Container>
        );
    }
}

export default LoadImages;
